import { render, staticRenderFns } from "./ImgUpload2.vue?vue&type=template&id=7a93bed2&scoped=true"
import script from "./ImgUpload2.vue?vue&type=script&lang=js"
export * from "./ImgUpload2.vue?vue&type=script&lang=js"
import style0 from "./ImgUpload2.vue?vue&type=style&index=0&id=7a93bed2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a93bed2",
  null
  
)

export default component.exports